(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chic-buybox-v2"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }

  function initCountdown(root) {
    var el = root.querySelector('[data-bb-countdown]');
    if (!el || el.dataset.bbBound) return;
    el.dataset.bbBound = 'true';

    var endAttr = el.getAttribute('data-end');
    var end = endAttr ? new Date(endAttr).getTime() : NaN;
    if (isNaN(end)) end = Date.now() + (24 * 60 * 60 * 1000);

    var dEl = el.querySelector('[data-bb-d]');
    var hEl = el.querySelector('[data-bb-h]');
    var mEl = el.querySelector('[data-bb-m]');
    var sEl = el.querySelector('[data-bb-s]');

    function tick() {
      var diff = Math.max(0, end - Date.now());
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (dEl) dEl.textContent = pad(d);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
    tick();
    el._bbInterval = window.setInterval(tick, 1000);
  }

  function clearCountdown(root) {
    var el = root.querySelector('[data-bb-countdown]');
    if (el && el._bbInterval) {
      window.clearInterval(el._bbInterval);
      el._bbInterval = null;
    }
  }

  function initGallery(root) {
    var wrap = root.querySelector('[data-bb-gallery]');
    if (!wrap || wrap.dataset.bbBound) return;
    wrap.dataset.bbBound = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-bb-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-bb-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bb-dots] .bb__dot'));
    var prev = root.querySelector('[data-bb-prev]');
    var next = root.querySelector('[data-bb-next]');
    var index = 0;

    function show(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, si) { s.classList.toggle('is-active', si === index); });
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === index); });
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        show(parseInt(t.getAttribute('data-index'), 10) || 0);
      });
    });
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
  }

  function initPricing(root) {
    var group = root.querySelector('[data-bb-pricing]');
    var options = Array.prototype.slice.call(root.querySelectorAll('.bb__option'));
    options.forEach(function (opt) {
      if (opt.dataset.bbBound) return;
      opt.dataset.bbBound = 'true';
      var radio = opt.querySelector('[data-bb-radio]');
      if (!radio) return;
      radio.addEventListener('change', function () {
        options.forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');
      });
    });
  }

  function initAccordion(root) {
    var acc = root.querySelector('[data-bb-accordion]');
    if (!acc || acc.dataset.bbBound) return;
    acc.dataset.bbBound = 'true';

    var triggers = Array.prototype.slice.call(acc.querySelectorAll('[data-bb-accordion-trigger]'));
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.bb__accordion-item');
        var panel = item ? item.querySelector('[data-bb-accordion-panel]') : null;
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!expanded));
        if (panel) panel.hidden = expanded;
        if (item) item.classList.toggle('is-open', !expanded);
      });
    });
  }

  function initTestimonials(root) {
    var wrap = root.querySelector('[data-bb-testimonials]');
    if (!wrap || wrap.dataset.bbBound) return;
    wrap.dataset.bbBound = 'true';

    var buttons = Array.prototype.slice.call(wrap.querySelectorAll('[data-bb-play]'));
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mediaWrap = btn.closest('[data-bb-video-wrap]');
        var videoUrl = btn.getAttribute('data-video-url');
        if (!mediaWrap) return;
        if (videoUrl) {
          var video = document.createElement('video');
          video.src = videoUrl;
          video.controls = true;
          video.autoplay = true;
          video.playsInline = true;
          video.className = 'bb__testimonial-video';
          mediaWrap.innerHTML = '';
          mediaWrap.appendChild(video);
        } else {
          btn.setAttribute('aria-disabled', 'true');
        }
      });
    });
  }

  function init(root) {
    initCountdown(root);
    initGallery(root);
    initPricing(root);
    initAccordion(root);
    initTestimonials(root);
  }

  function teardown(root) {
    clearCountdown(root);
  }

  document.querySelectorAll('[data-bb]').forEach(init);

  document.addEventListener('shopify:section:load', function (evt) {
    var root = evt.target.querySelector('[data-bb]');
    if (root) init(root);
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    var root = evt.target.querySelector('[data-bb]');
    if (root) teardown(root);
  });

  document.addEventListener('shopify:section:select', function (evt) {
    var root = evt.target.querySelector('[data-bb]');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
